import Confirm from './Confirm';

const Plugin = function Plugin(Vue) {
  this.Vue = Vue;
  this.mounted = false;
  this.$root = {};
};

Plugin.prototype.mountIfNotMounted = function mountIfNotMounted() {
  if (this.mounted === true) {
    return;
  }

  this.$root = (() => {
    const ConfirmConstructor = this.Vue.extend(Confirm);
    const node = document.createElement('div');
    document.querySelector('#app').appendChild(node);

    return new ConfirmConstructor().$mount(node);
  })();

  this.mounted = true;
};

Plugin.prototype.destroy = function destroy() {
  if (this.mounted === true) {
    const elem = this.$root.$el;
    this.$root.$destroy();
    this.$root.$off();
    elem.remove();
    this.mounted = false;
  }
};

Plugin.prototype.open = function open(content, title, disableCancel) {
  return new Promise(resolve => {
    this.mountIfNotMounted();
    this.$root.open({
      content,
      title,
      disableCancel,
      resolve,
    });
  });
};

Plugin.install = function install(vue, options) {
  const Vue = vue;
  Vue.confirm = new Plugin(Vue, options);
  Vue.prototype.$confirm = Vue.confirm;
};

export default Plugin;
